import Vue from 'vue'

const deep_settings_roles = ['responsabile','amministrazione','direzione']
let stati = [
  {
    label: 'Tutti',
    id: 'null',
    num: -1,
    icon: 'icon-code',
  },
  {
    label: 'Creato',
    id: 'create',
    num: 0,
    icon: 'icon-save',
  },
  {
    label: 'Approvato',
    id: 'approve',
    num: 1,
    icon: 'icon-thumbs-up',
  },
  {
    label: 'Verificato',
    id: 'verify',
    num: 2,
    icon: 'icon-check',
  },
  {
    label: 'Confermato',
    id: 'confirm',
    num: 3,
    icon: 'icon-check-circle',
  },
  {
    label: 'Richiesta modifica',
    id: 'request',
    num: 4,
    icon: 'icon-help-circle',
  },
  {
    label: 'Modificato',
    id: 'update',
    num: 5,
    icon: 'icon-edit',
  },
  {
    label: 'Completato',
    id: 'complete',
    num: 6,
    icon: 'icon-maximize',
  },
  {
    label: 'Assicurazione',
    id: 'insurance',
    num: 7,
    icon: 'icon-corner-down-left',
  },
  {
    label: 'Conclusa', // ex Pagato
    id: 'paid',
    num: 8,
    icon: 'icon-dollar-sign',
  },
  {
    label: 'Rifiutato',
    id: 'refuse',
    num: 9,
    icon: 'icon-shield-off',
  }
]

Vue.prototype.$rimb = {
  stati,
  label_of: id => stati.find(x => x.id == id).label,
  icon_of: id => stati.find(x => x.id == id).icon,
  label_of_next(stato) {
    let i = this.index_of(stato)
    return stati[i+1].label
  },
  index_of: id => stati.findIndex(x => x.id == id),

  formatDateNew(date) {
    date = new Date(date)
    var options = { year: "numeric", month: "short", day: "numeric" }
    return date.toLocaleDateString("it-IT", options).split(' ').map( (e) => e.charAt(0).toUpperCase() + e.substring(1)).join(' ')
  },

  generatePDFrimborso(p_to_print) {
    // console.log(p_to_print);
    p_to_print['importo'] = (new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 })).format(p_to_print['importo'])
    p_to_print['importo_pagato'] = (new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 })).format(p_to_print['importo_pagato'])

    p_to_print['data_inserimento'] = this.formatDateNew(p_to_print['data_inserimento'])
    p_to_print['data_modifica'] = p_to_print['data_modifica'] ? this.formatDateNew(p_to_print['data_modifica']) : ''

    // if (p_to_print['azienda']['contatti'] > 1) p_to_print['azienda']['contatti'].pop()
    if (p_to_print.azienda && p_to_print.azienda.id) {
      // p_to_print['azienda']['contatti'] = p_to_print['azienda']['contatti'] ? p_to_print['azienda']['contatti'].filter( c => { c.id_ruolo == 93 || c.id_ruolo == 1 }) : []

      p_to_print.azienda.contatti.forEach( el => {
        el['contatto']['data_nascita'] = this.formatDateNew(el['contatto']['data_nascita'])
      });

      p_to_print['azienda']['codice_ufficio'] = p_to_print['ufficio'].descrizione

      p_to_print['azienda']['servizi_attivi'] = p_to_print['azienda']['servizi_attivi'].map( el => el.servizio.categoria)
      p_to_print['azienda']['servizi_attivi'] = p_to_print['azienda']['servizi_attivi'].filter((x, i, a) => a.indexOf(x) == i);
      p_to_print['azienda']['servizi_attivi'] = p_to_print['azienda']['servizi_attivi'].filter(el => el !== "");
    }
    // if (p_to_print.contatto && p_to_print.contatto.id) {
    //   p_to_print['contatto']
    // }

    return p_to_print
  },
}
